var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 23,
  viewBox: "0 0 22 23",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.168 11.783c0-.766-.069-1.502-.196-2.21H10.8v4.179h5.812a4.968 4.968 0 0 1-2.155 3.26v2.709h3.49c2.043-1.88 3.221-4.649 3.221-7.938z",
  fill: "#4285F4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8 22.338c2.916 0 5.36-.968 7.148-2.617l-3.49-2.71c-.968.648-2.205 1.031-3.658 1.031-2.813 0-5.194-1.9-6.043-4.452H1.149v2.798a10.796 10.796 0 0 0 9.651 5.95z",
  fill: "#34A853",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.757 13.59a6.492 6.492 0 0 1-.339-2.052c0-.712.123-1.404.339-2.052V6.687H1.149A10.796 10.796 0 0 0 0 11.537c0 1.743.417 3.393 1.149 4.85l3.608-2.797z",
  fill: "#FBBC05",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8 5.033c1.586 0 3.01.545 4.129 1.615l3.097-3.098C16.156 1.808 13.711.738 10.8.738c-4.222 0-7.874 2.42-9.651 5.95l3.608 2.798c.85-2.553 3.23-4.453 6.043-4.453z",
  fill: "#EA4335",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 .738h21.6v21.6H0z"
}))));
export default SvgIconGoogle;